'use strict';
/* ==========================================================================
   core-local/hooks.js — "It's Only a Theory?!": this lesson's hooks into the shared engine v2
   (shared/engine/v2/core/game.js reads window.LessonHooks). The physics cast (DESIGN.md §3), reused from Energy.

   speakers: the name tag + colour of each voice in the portrait dock's captions (core/dock.js): Dr. Voss = grease-
             pencil red, Max = teal (Energy's pair).
   completeCard: the TESTED card: the finished step's card.done + where to go next (see below).
   captions: fallback caption text + speaker for every line in content/script.json (segments + responses), so the
             video works before any voice is recorded. assets/vo/lines.json / who.json (what was recorded) win.
   Puppets: voss (poses voss, voss_point) and max (max_cross, max_point) come with core/puppet.js (Energy's cast:
            Puppet.POSES / DEFAULT / NATIVE already know them: voss 0, voss_point 0, max_cross −1, max_point +1). The
            art is a copy of lessons/energy/assets/img/ in assets/img/.
   ========================================================================== */
window.LessonHooks = {
  speakers: { voss: { name: 'Dr. Voss', color: '#b8321f' }, max: { name: 'Max', color: '#1f7a6e' } },
  /* the TESTED card. lesson.json's steps[].card.next describes the step AFTER that step ("video" → "Next: Fix the
     Poster (card 2)."), so the next line is the finished step's own card.next when the first unstamped step is the
     one right after it; otherwise "Next: <title> (card k)." */
  completeCard(stepId, progress) {
    const L = (window.Game && Game.lesson) || {}, steps = L.steps || [], C = L.completeCard || {}, st = progress.stamps || {};
    const me = steps.find(s => s.id === stepId) || {};
    const done = (me.card && me.card.done) || 'Tested.';
    const k = steps.findIndex(s => !st[s.id]);
    let next;
    if (k < 0) next = C.allDone || 'All four tested! Lesson complete.';
    else {
      const prev = steps[k - 1];
      next = prev && prev.id === stepId && prev.card && prev.card.next ? prev.card.next : `Next: ${steps[k].title || steps[k].id} (card ${k + 1}).`;
    }
    return { title: C.title || 'TESTED', lines: [done, next] };
  },
  captions({ script }) {
    const text = {}, who = {};
    const add = l => { text[l.id] = l.text; who[l.id] = l.who; };
    if (script) { script.segments.forEach(sg => (sg.lines || []).concat(sg.after || []).forEach(add)); (script.responses || []).forEach(add); }
    return { text, who };
  },
};
